/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

import { calmGrowthPalette } from "@/theme/emo-coach-theme"

const tintColorLight = calmGrowthPalette.semantic.coach
const tintColorDark = "#fff"

export const Colors = {
  light: {
    text: "#11181C",
    background: "#fff",
    tint: tintColorLight,
    icon: "#687076",
    tabIconDefault: "#687076",
    tabIconSelected: tintColorLight,
  },
  dark: {
    // Base colors
    text: "#ECEDEE",
    background: "#151718",
    tint: tintColorDark,
    icon: "#9BA1A6",
    tabIconDefault: "#9BA1A6",
    tabIconSelected: tintColorDark,

    // EMO.coach Theme Colors
    // Backgrounds
    surface: calmGrowthPalette.base.surface, // Main app background
    surfaceSecondary: calmGrowthPalette.base.surfaceSecondary, // Card/container backgrounds
    surfaceTertiary: calmGrowthPalette.base.surfaceTertiary, // Secondary containers
    surfaceElevated: calmGrowthPalette.base.surfaceElevated,

    // Text
    textPrimary: calmGrowthPalette.base.textPrimary, // Main text color
    textSecondary: calmGrowthPalette.base.textSecondary, // Secondary text
    textTertiary: calmGrowthPalette.base.textTertiary, // Muted text

    // Accents
    primary: calmGrowthPalette.semantic.coach, // Coach and primary CTA teal
    primaryForeground: "#022E27", // High-contrast foreground for filled teal CTAs
    success: calmGrowthPalette.semantic.growth, // Growth emerald
    accentPink: calmGrowthPalette.semantic.proof, // Legacy alias for proof amber
    accentOrange: calmGrowthPalette.semantic.proof, // Proof and achievement amber
    accentPurple: calmGrowthPalette.semantic.skill, // Skill and EQ-domain indigo
    accentBlue: calmGrowthPalette.semantic.coach, // Legacy alias for coach teal
    proof: calmGrowthPalette.semantic.proof,
    growth: calmGrowthPalette.semantic.growth,
    skill: calmGrowthPalette.semantic.skill,

    // Status colors
    error: calmGrowthPalette.semantic.danger,
    warning: calmGrowthPalette.semantic.proof,

    // Borders
    border: calmGrowthPalette.base.border,
    borderSecondary: calmGrowthPalette.base.surfaceTertiary,

    // Interactive states
    hover: `${calmGrowthPalette.semantic.coach}80`,
    active: `${calmGrowthPalette.semantic.coach}B3`,
  },
}
